import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import * as $ from 'jquery';
import { map, Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ComponentService {

  constructor(
    public afs: AngularFirestore) { }
  // Generic helper method to set layout data (reduces duplication)
  private async setLayoutData(collectionPath: string, uid: string, dataKey: string, data: any): Promise<void> {
    try {
      await this.afs
        .doc(`${collectionPath}/${uid}`)
        .set({ [dataKey]: data }, { merge: true });
      console.log("updated");
    } catch (error) {
      console.error(`Error updating layout in ${collectionPath}:`, error);
    }
  }

  async setTempLayout(data, uid) {
    await this.setLayoutData('/layout-json-temp', uid, 'layout_json_temp', data);
  }

  async setSavedLayout(data, uid) {
    await this.setLayoutData('/layout-json-saved', uid, 'layout_json_saved', data);
  }

  // Generic helper method to get layout data (reduces duplication)
  private async getLayoutData(collectionPath: string, uid: string): Promise<any> {
    try {
      const layoutRef = this.afs.doc(`${collectionPath}/${uid}`);
      const doc: any = await layoutRef.get().pipe(take(1)).toPromise();
      return doc?.data() || null;
    } catch (error) {
      console.error(`Error getting layout data from ${collectionPath}:`, error);
      return null;
    }
  }

  async getTempLayout(uid) {
    return this.getLayoutData('/layout-json-temp', uid);
  }

  async getSavedLayout(uid) {
    return this.getLayoutData('/layout-json-saved', uid);
  }

  //for bundle
  async getBundleTempLayout(uid) {
    return this.getLayoutData('/bundle-json-temp', uid);
  }

  async getBundleSavedLayout(uid) {
    return this.getLayoutData('/bundle-json-saved', uid);
  }

  async setBundleTempLayout(data, uid) {
    await this.setLayoutData('/bundle-json-temp', uid, 'bundle_json_temp', data);
  }

  async setBundleSavedLayout(data, uid) {
    await this.setLayoutData('/bundle-json-saved', uid, 'bundle_json_saved', data);
  }

  //for menu 
  async getMenuTempLayout(uid) {
    return this.getLayoutData('/menu-json-temp', uid);
  }

  async getMenuSavedLayout(uid) {
    return this.getLayoutData('/menu-json-saved', uid);
  }

  async setMenuTempLayout(data, uid) {
    await this.setLayoutData('/menu-json-temp', uid, 'menu_json_temp', data);
  }

  async setMenuSavedLayout(data, uid) {
    await this.setLayoutData('/menu-json-saved', uid, 'menu_json_saved', data);
  }
  

  async getRestaurantTempLayout(uid) {
    return this.getLayoutData('/restaurant-json-temp', uid);
  }

  async getRestaurantSavedLayout(uid) {
    return this.getLayoutData('/restaurant-json-saved', uid);
  }

  async setRestaurantTempLayout(data, uid) {
    await this.setLayoutData('/restaurant-json-temp', uid, 'restaurant_json_temp', data);
  }

  async setRestaurantSavedLayout(data, uid) {
    await this.setLayoutData('/restaurant-json-saved', uid, 'restaurant_json_saved', data);
  }
  async getCommunityTempLayout(uid) {
    return this.getLayoutData('/community-json-temp', uid);
  }

  async getCommunitySavedLayout(uid) {
    return this.getLayoutData('/community-json-saved', uid);
  }

  async setCommunityTempLayout(data, uid) {
    await this.setLayoutData('/community-json-temp', uid, 'community_json_temp', data);
  }

  async setCommunitySavedLayout(data, uid) {
    await this.setLayoutData('/community-json-saved', uid, 'community_json_saved', data);
  }
  getPrice(data, digital_coupon) {
    var temp = document.createElement('div');
    temp.innerHTML = data;
    let label1;
    let label2;
    let label3;
    var formate = this.getFormate(data, digital_coupon)
    if (digital_coupon) {
      label1 = $(temp).find('#sale_price_doller').text().trim()
      label2 = $(temp).find('#sale_price_cent').text().trim()
      label3 = $(temp).find('#sale_price_for_value').text().trim()
    } else {
      label1 = $(temp).find('#dollar').text().trim()
      label2 = $(temp).find('#cent').text().trim()
      label3 = $(temp).find('#third').text().trim()
    }
    switch (formate) {
      case 'format1':
        return '$' + label1;
      case 'format2':
      case 'final_price_format1':
      case 'sale_price_format1':
        if (label1 && label2) {
          return '$' + label1 + '.' + label2;
        } else if (label1 && label2 == '') {
          return '$' + label1;
        } else {
          return '$' + '0' + '.' + label2;
        }
      case 'format3':
        return '$' + label1 + '.' + label2 + '/LB';
      case 'format4':
        return '$' + label1 + '.' + label2 + '/EA';
      case 'format5':
        if (label2 && label3) {
          return label1 + ' For $' + label2 + '.' + label3;
        } else if (label2 && label3 == '') {
          return label1 + ' For $' + label2;
        } else {
          return label1 + ' For $' + '0' + '.' + label3;
        }
      case 'format6':
        return 'Buy ' + label1 + ' Get ' + label2 + ' For ' + (label3 ? label3 : 'Free');
      case 'format7':
        return '$' + label1 + '.' + label2 + ' Off';
      case 'final_price_format2':
      case 'sale_price_format2':
        if (label1 && label2) {
          return label3 + ' For $' + label1 + '.' + label2;
        } else if (label1 && label2 == '') {
          return label3 + ' For $' + label1;
        } else {
          return label3 + ' For $' + '0' + '.' + label2;
        }
      default:
        return '';
    }
  }
  getFormate(data, digital_coupon) {
    var temp = document.createElement('div');
    temp.innerHTML = data;
    if (digital_coupon) {
      return temp?.getElementsByClassName("price_format_wrapper")[0]?.getAttribute("id") || ''
    } else {
      return temp?.getElementsByClassName("circular-card-deal-wrapper")[0]?.getAttribute("id") || ''
    }
  }

  getValidCoupons(current_store_uid): any {
    return this.afs.collection('/coupons', ref => ref.where('store_uid', '==', current_store_uid).where('is_publish', '==', true).orderBy('created_at', 'desc')).snapshotChanges().pipe(map(data => {
      return data.map(e => {
        const validTillTimestamp = e.payload.doc.data()['valid_till'].seconds * 1000;
        const validTillDate = new Date(validTillTimestamp);
        validTillDate.setHours(0, 0, 0, 0);
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        if (validTillDate >= currentDate) {
          return {
            uid: e.payload.doc.id,
            coupon_image: e.payload.doc.data()['coupon_image'] ? e.payload.doc.data()['coupon_image'] : "https://placehold.co/300x200/2e2e2e/2e2e2e",
            upc: e.payload.doc.data()['upc'],
            coupon_description: e.payload.doc.data()['coupon_description'],
            label: e.payload.doc.data()['label'],
            coupon_code: e.payload.doc.data()['coupon_code'],
            valid_from: e.payload.doc.data()['valid_from'],
            valid_till: e.payload.doc.data()['valid_till'],
          };
        } else {
          return {
            uid: e.payload.doc.id,
            valid_till: 'expired'
          }
        }
      });
    }));
  }
}
